import { extractDomain, extractFullDomain } from "../utilities/stringUtils";
import { isNew } from "../Constants";

export const computeUserProps = (user: any) => {
  let full_domain = extractFullDomain(user.email);
  let domain = extractDomain(user.email);
  const excludeDomains = ["@poly.com"];
  const isPoly = excludeDomains.some(domain => user.email.endsWith(domain));
  return {
    isPoly: isPoly,
    domain: domain,
    full_domain: full_domain,
    isNew: user[isNew]
  };
};
